'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'up-to-line';
var width = 384;
var height = 512;
var aliases = ["arrow-alt-to-top"];
var unicode = 'f34d';
var svgPathData = 'M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 64C14.3 64 0 49.7 0 32zM175 135c9.4-9.4 24.6-9.4 33.9 0L353 279c6.9 6.9 8.9 17.2 5.2 26.2S345.7 320 336 320l-80 0 0 144c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-144-80 0c-9.7 0-18.5-5.8-22.2-14.8S24.2 285.9 31 279L175 135z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUpToLine = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;